import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {Grid} from '@mui/material';
import {ContScoringPage, BtnOnbard, ContButton, IndentityPhoneImg } from './ScoringPage.styles';
import { IdentityCont, ContTextIdentity, TextIdentitySummary, ContCardIdentity, ContOnb, ContHowWork, ContTextDescHowWork, TitleHowWork, TextDescHowWork } from '../globalpages.styles';
import ButtonSpecial from '../../components/ButtonSpecial';
import ActionDemo from '../../components/ActionDemo/index';
import { CoreBancarioFAQ } from '../../components/CoreBancarioFAQ';
import ScoringImg from '../../assets/images/Servicios/img-scoring.webp';
import ScoringService from '../../assets/images/Servicios/img-scoring-ben.webp';
import ServicesIntegrations from '../../components/ServicesIntegrations/index';
import ServicesBeneficios from '../../components/ServicesBeneficios/index';
import Tiaxa from  '../../assets/images/Servicios/tiaxca-services.webp';
import Palenca from  '../../assets/images/Servicios/palenca-service.webp';
import Nuba from  '../../assets/images/Servicios/nubarium-services.webp';

const ScoringItems = [
  {
    title: 'Confiabilidad y transparencia ',
  },
  {
    title: 'Adquisición de clientela digital',
  },
  {
    title: 'Implementación por medio de API',
  },
  {
    title: 'Cumplimiento regulatorio',
  },
  {
    title: 'Reportes automatizados',
  },
];

const scoreAlternativoFaqData = [
  {
    id: 1,
    question: '¿Qué es Score Alternativo?',
    answer: 'El Score Alternativo es un modelo de evaluación de riesgo que utiliza fuentes de datos no tradicionales para complementar o fortalecer el análisis crediticio. A diferencia del score tradicional basado principalmente en historial en buró, el Score Alternativo incorpora señales adicionales de comportamiento financiero y transaccional para ofrecer una visión más completa del solicitante.',
    relatedLinks: [
      {
        label: 'Score Alternativo',
        href: 'https://dynamicore.io/score-alternativo',
      },
      {
        label: 'Score Alternativo, un aliado para la inclusión financiera',
        href: 'https://blog.dynamicore.io/b/score-alternativo-un-aliado-para-la-inclusion-financiera/',
      },
    ],
  },
  {
    id: 2,
    question: '¿Qué data adicional puedo obtener con Score Alternativo?',
    answer: 'Podemos verificar línea telefónica, correo electrónico, consumo o uso de aplicaciones.',
  },
  {
    id: 3,
    question: '¿Puedo integrarlo a mi modelo de score actual?',
    answer: 'Sí, puedes agregarlos cómo capa de seguridad adicional a tu score tradicional.',
  },
];

export const ScoringPage = () => {
  const { t } = useTranslation();
  const imagesToShow = [
    { src: Tiaxa, visible: true, alt: 'Logo Tiaxa', },
    { src: Palenca, visible: true, alt: 'Logo Palenca', },
    { src: Nuba, visible: true, alt: 'Logo Nubarium', },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <ContScoringPage id={'ContScoringPage'}>

      <ContCardIdentity id={'ContCardIdentity'}>
        <IdentityCont>
          <Grid container spacing={2} className={'ContCardIdentity GridBlueCard'}>
            <Grid item xs={12} sm={12} md={6} order={{ xs: 1, sm: 1, md: 2 }} style={{paddingLeft: '5%'}}>
              <ContOnb>
                <BtnOnbard>
                  {t('Score Alternativo')}
                </BtnOnbard>
              </ContOnb>
              <ContTextIdentity>
                {t('Llega a personas sin historial de crédito con metadatos')}
              </ContTextIdentity>
              <TextIdentitySummary>
                {t('Obtén la puntuación de crediticia de tus clientes por medio de su comportamiento digital.')}
              </TextIdentitySummary>
              <ContButton>
                <ButtonSpecial text={'Prueba la versión Demo'} type={'/'} linkTo={'/contacto'} target={'_self'} theme={'secondary'}/>
              </ContButton>
            </Grid>
            <Grid item xs={12} sm={12} md={6} 
              order={{ xs: 2, sm: 2, md: 1 }}
              className={'GridStylesCardImage'}
            >
              <IndentityPhoneImg src={ScoringImg} alt={'Análisis de score alternativo'} width={430} visible={true} />
            </Grid>
          </Grid>
        </IdentityCont>
      </ContCardIdentity>

      <ContHowWork id={'ContHowWork'}>
        <TitleHowWork>
          {t('¿Cómo funciona?')}
        </TitleHowWork>
        <ContTextDescHowWork>
          <TextDescHowWork>
            {t('Analiza millones de metadatos y estadísticas mediante el smartphone de tus clientes, generando patrones predictivos los cuales te ayudarán a definir su score.')}
          </TextDescHowWork>
        </ContTextDescHowWork>

        <ContButton>
          <ButtonSpecial text={'Prueba la versión Demo'} type={'/'} linkTo={'/contacto'} target={'_self'} theme={'primary'}/>
        </ContButton>
      
      </ContHowWork>

      <ServicesBeneficios items={ScoringItems} image={ScoringService} alt={'Score alternativo dynamicore'} />

      <ServicesIntegrations imagesToShow={imagesToShow} noSpace={false} text={'Amplia tu mercado con ayuda de nuestros proveedores de Score Alternativo.'}/>

      <CoreBancarioFAQ faqData={scoreAlternativoFaqData} />

      <ActionDemo />
    </ContScoringPage>
  )
}
